import { createSlice } from "@reduxjs/toolkit";
import { googleOAuth, login } from "./AuthThunk";

export const Auth = createSlice({
  name: "Auth",
  initialState: {
    isLoading: false,
    rememberMe: false,
    credentials: {
      email: "",
      password: "",
    },
    user: {},
  },
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    setRememberMe(state, action) {
      state.rememberMe = action.payload;
    },
    setUserProfilePic(state, action) {
      state.user.profilePic = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.isLoading = false;
      state.user = action.payload;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(googleOAuth.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(googleOAuth.fulfilled, (state, action) => {
      state.isLoading = false;
      state.user = action.payload;
    });
    builder.addCase(googleOAuth.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export const user = (state) => state.auth.user;
export const token = (state) => state.state.auth.user.token;

export const { setUser, setRememberMe, setUserProfilePic } = Auth.actions;

export default Auth.reducer;
